"use client"

import { useId, type ReactNode } from "react"
import { Checkbox as UiCheckbox } from "@/components/ui/checkbox"
import { Label as UiLabel } from "@/components/ui/label"
import { cn } from "@/lib/utils"

/*
 * MARK V — Checkbox (wrapper compass sobre o primitivo shadcn/Radix).
 * Controlado (`checked` + `onCheckedChange`) ou não-controlado (`defaultChecked`),
 * com label + descrição inline opcionais. API espelha o DS
 * (mark-v-design-system/components/forms/Checkbox) e o wrapper Switch.
 */

export type CheckboxProps = {
  checked?: boolean
  defaultChecked?: boolean
  onCheckedChange?: (checked: boolean) => void
  disabled?: boolean
  label?: ReactNode
  description?: ReactNode
  id?: string
  name?: string
  // Valor enviado no form quando marcado (padrão do Radix: "on").
  value?: string
  className?: string
}

export function Checkbox({
  checked,
  defaultChecked,
  onCheckedChange,
  disabled,
  label,
  description,
  id,
  name,
  value,
  className,
}: CheckboxProps) {
  const reactId = useId()
  const boxId = id ?? `compass-checkbox-${reactId}`

  return (
    <div className={cn("flex items-start gap-3", className)}>
      <UiCheckbox
        id={boxId}
        className="mt-0.5"
        {...(checked !== undefined ? { checked } : {})}
        {...(defaultChecked !== undefined ? { defaultChecked } : {})}
        {...(onCheckedChange ? { onCheckedChange: (v) => onCheckedChange(v === true) } : {})}
        {...(disabled !== undefined ? { disabled } : {})}
        {...(name !== undefined ? { name } : {})}
        {...(value !== undefined ? { value } : {})}
      />
      {label ? (
        <div className="flex flex-col">
          <UiLabel htmlFor={boxId} className="text-sm text-markv-text-700">
            {label}
          </UiLabel>
          {description ? (
            <span className="text-xs text-markv-text-400">{description}</span>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}
